import moment from "moment";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/lib/css/mdb.min.css';

import Vue from 'vue';
import App from './App';
import router from './router';
import * as VueGoogleMaps from 'vue2-google-maps';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: 'AIzaSyCW3xP4m62KqAYDXHun2CrifnvwY4qMXDo',
  authDomain: 'sytsma-farms-manager.firebaseapp.com',
  databaseURL: 'https://sytsma-farms-manager.firebaseio.com',
  projectId: 'sytsma-farms-manager',
  storageBucket: 'sytsma-farms-manager.appspot.com',
  messagingSenderId: '522276061164',
  appId: '1:522276061164:web:b597066fcd71b9ff490ac9',
  measurementId: 'G-X3H6Q00T7F',
});

Vue.filter('dateFormat', function(date) {
    return moment(date).format("MMMM Do YYYY");
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCW3xP4m62KqAYDXHun2CrifnvwY4qMXDo',
    libraries: 'places',
  },
});

Vue.config.productionTip = process.env.NODE_ENV === 'production';

let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
});

firebase.firestore().enablePersistence();
